import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressSpinnerService {

  constructor() { }

  private _progressSpinner$ = new Subject<boolean>();
  public progressSpinner = this._progressSpinner$.asObservable();

  progressSpinnerChange(showSpinner: boolean): void {
    this._progressSpinner$.next(showSpinner);
  }
}
